import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import Urologycon from "./Urologycon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Urology() {
  useEffect(() => {
    movetop();
  }, []);
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Urologycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };
  return (
    <>
      <Helmet>
        <title>Best Urology Clinic in Whitefield</title>
        <meta
          name="description"
          content="We are the Best Urology Clinic in Whitefield and Vijayanagar. If you are looking for this then feel free to contact us today or call us now."
        />
        <meta
          name="keywords"
          content="Best Urology Clinic in Whitefield, Best Urology Clinic in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/besturologyservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/besturologyservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert urology services including diagnosis and treatment of urinary tract disorders, kidney and bladder issues, prostate care, men’s reproductive health, and minimally invasive urological procedures by experienced urologists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Urological consultation and diagnosis",
              "Urinary tract infection care",
              "Kidney stone management",
              "Prostate health evaluation",
              "Bladder health and function care",
              "Men's reproductive health support",
              "Minimally invasive urology procedures",
            ],
            keywords: [
              "best urology services in Immadihalli",
              "best urology services in Whitefield",
              "best urology services in Bangalore",
              "best urology services in Kundalahalli",
              "best urology services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Urology Clinic in Whitefield apart as a leader in Urology services.
        Contact us for the best urolog clinic in Whitefield.
      </h2>
      <Servicebanner name="Urology" banner={"../photo/dd25.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Urology;
